module.exports = __webpack_public_path__ + "static/amazonuk-6a732ff42d56d3be705c06064c62b20b.png";